
import { Component, Vue } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
const { VUE_APP_FCAPI: FCAPI } = process.env;
import { namespace } from 'vuex-class';
const Hundun = namespace('Hundun');
const getUrl = require('baimahu/url-with-param');

const API = {
  get_list: `${FCAPI}/boss/hundun/setting/teacher`,
  edit_teacher: `${FCAPI}/boss/hundun/setting/teacher`,
};
interface Form {
  weixin_nickname: string;
  charge: string;
}
function initForm() {
  return {
    weixin_nickname: '',
    charge: '',
  };
}
@Component
export default class WechatList extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.Action('FETCH_TEACHER') getTeacher: any; //获取教师
  /* eslint-enable */
  status = [
    {
      id: 2,
      value: '已停用',
    },
    {
      id: 1,
      value: '使用中',
    },
  ];
  search_form: Form = initForm();
  locale = zhCN;
  form: any;
  edit_id = 0;
  show_modal = false;
  isloading = false;
  is_edit = false;
  table_data: any = {};
  checkPhone() {
    const phone = this.form.getFieldValue('phone');
    if (phone) {
      return /^1[3456789]\d{9}$/.test(phone);
    } else {
      return true;
    }
  }
  //切换分页
  changePage(page: any) {
    this.getWechatList(page.current);
  }
  //分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`,
    };
  }
  async getWechatList(page = 1) {
    this.isloading = true;
    const send_data = {
      weixin_nickname: this.search_form.weixin_nickname
        ? this.search_form.weixin_nickname
        : '',
      charge: this.search_form.charge ? this.search_form.charge : '',
      current: page,
    };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    console.log(res)
    if (res.data.status === 200) {
      this.table_data = res.data.data ? res.data.data : [];
      this.isloading = false;
    }
  }
  //新增班主任微信号
  addWechat() {
    this.is_edit = false;
    this.show_modal = true;
  }
  // 编辑弹框打开
  editWechat(record: any) {
    this.is_edit = true;
    this.edit_id = record.id;
    this.show_modal = true;
    //确保先渲染在加载数据。
    this.$nextTick(() => {
      this.form.setFieldsValue({
        wechat_nickname: record.weixin_nickname,
        wechat_number: record.weixin_number,
        phone: record.mobile,
        leader: record.charge,
        status: record.status,
      });
    });
  }
  // 编辑
  async editTeacher(id: number, send_data: any) {
    const res: any = await this.$axios.put(
      `${API.edit_teacher}/${id}`,
      send_data
    );
    if (res.data.status === 200) {
      this.getWechatList(this.table_data.current);
      this.getTeacher();
      this.$message.success('编辑成功');
      this.cancel();
    }
  }
  async addTeacher(send_data: any) {
    const res: any = await this.$axios.post(API.edit_teacher, send_data);
    if (res.data.status === 200) {
      this.getWechatList(this.table_data.current);
      this.getTeacher();
      this.$message.success('新增成功');
      this.cancel();
    }
  }
  //表单数据确认提交
  submit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        const send_data = {
          weixin_nickname: values.wechat_nickname,
          weixin_number: values.wechat_number,
          mobile: values.phone ? values.phone : '',
          charge: values.leader,
          status: values.status,
        };
        if (this.is_edit) {
          this.editTeacher(this.edit_id, send_data);
        } else {
          this.addTeacher(send_data);
        }
        console.log('Received values of form: ', values);
      }
    });
  }
  clearForm() {
    this.search_form = initForm();
  }
  cancel() {
    this.form.resetFields([
      'wechat_nickname',
      'wechat_number',
      'phone',
      'leader',
      'status',
    ]);
    this.show_modal = false;
  }
  //form实例初始化必须这么写(antd和ts的原因)
  beforeCreate() {
    this.form = this.$form.createForm(this);
  }
  created() {
    this.getWechatList(1);
  }
}
